const data = {
  fastcompany: {
    logo:
      '//a.fastcompany.net/image/upload/v1488299125/fc/fastcompany-logo.svg',
    title: 'Fast Company',
    subscribeLink: 'https://www.fastcompany.com/combo',
    newsletterLink: 'https://www.fastcompany.com/newsletters',
    topics: [
      {
        url: '/co-design',
        title: 'Co.Design'
      },
      {
        url: '/technology',
        title: 'Tech'
      },
      {
        url: '/work-life',
        title: 'Work Life'
      },
      {
        url: '/news',
        title: 'News'
      },
      {
        url: '/impact',
        title: 'Impact'
      },
      {
        url: '/podcasts',
        title: 'Podcasts',
        removeOnScale: true,
        external: true
      },
      {
        url: '/videos',
        title: 'Video'
      },
      {
        url: '/recommender',
        title: 'Recommender'
      },
      {
        url: '/section/innovation-festival-360',
        title: 'Innovation Festival 360',
        mobileTitle: 'IF360'
      },
      {
        url:
          'https://www.fastcompany.com/subscribe?cid=dan904:701:000:SCTA_&utm_source=paidDisplayOn&utm_medium=edit%20top%20nav&utm_campaign=dan904:701:000:SCTA_',
        title: 'Subscribe',
        external: true,
        // removeOnScale: true,
        bold: true,
        subtopics: [
          {
            title: 'Newsletters',
            url: '/newsletters'
          },
          {
            title: 'Magazine',
            external: true,
            url:
              'https://www.fastcompany.com/subscribe?cid=dan904:701:000:SCTA_&utm_source=paidDisplayOn&utm_medium=edit%20top%20nav&utm_campaign=dan904:701:000:SCTA_'
          }
        ]
      }
    ],
    channels: [
      {
        logo: '',
        title: 'FastCo Works',
        items: [
          {
            url: '/fcw/aws',
            title: 'AWS'
          },
          {
            url: '/fcw/genpact',
            title: 'Genpact'
          },
          {
            url: '/fcw/ibm',
            title: 'IBM'
          }
        ]
      }
    ]
  }
};

export default data;
